import { NUMBER_TO_ARABIC_MONTHS } from "constants/constants";
import React from "react";

const currentMonth = new Date().getMonth() + 1;

const MonthNavigator = ({ selectedMonthIdx, onPrev, onNext }) => {
    const btnClassName = "w-[30px] h-[30px] flex justify-center items-center pb-1 text-[18px] text-[#0af] font-black bg-[#181f2e] border-none rounded-full shadow-md cursor-pointer transition-colors duration-200";

    const placeholderClassName = "w-[30px] h-[30px] rounded-full invisible";

    return (
        <div className="w-full flex justify-center items-center gap-[18px] text-white" >
            {/* Previous Button */}
            {selectedMonthIdx > 1 ? (
                <button className={btnClassName} onClick={onPrev} title="الشهر السابق">
                    &#8592;
                </button>
            ) : (
                <div className={placeholderClassName} />
            )}

            {/* Month Name */}
            <span className="min-w-[80px] text-[15px] text-center font-bold tracking-[1px]" >
                {NUMBER_TO_ARABIC_MONTHS[selectedMonthIdx || currentMonth]}
            </span>

            {/* Next Button */}
            {selectedMonthIdx < currentMonth ? (
                <button className={btnClassName} onClick={onNext} title="الشهر التالي">
                    &#8594;
                </button>
            ) : (
                <div className={placeholderClassName} />
            )}
        </div>
    );
}

export default MonthNavigator;